export const routeNames = new Map([
  ['auction', 'auction'],
  ['buyingActive', 'BuyingActive'],
  ['buyingRunList', 'BuyingRunList'],
  ['forgot', 'forgot'],
  ['login', 'login'],
  ['logout', 'logout'],
  ['marketplace', 'Marketplace'],
  ['myAcv', 'MyACV'],
  ['myAcvSold', 'MyAcvSold'],
  ['myAcvActive', 'MyAcvActive'],
  ['myAcvActiveSelling', 'MyAcvActiveSelling'],
  ['myAcvMyInventory', 'MyAcvMyInventory'],
  ['myAcvSaved', 'MyAcvSaved'],
  ['notifications', 'notifications'],
  ['registration', 'RegistrationLandingPage'],
  ['registration_v2', 'RegistrationLandingPageV2'],
  ['registrationForm', 'Registration Form'],
  ['registrationForm_v2', 'RegistrationFormV2'],
  ['registrationEmailVerification_v2', 'RegistrationEmailVerificationV2'],
  ['registrationIdentityVerified_v2', 'RegistrationIdentityVerifiedV2'],
  ['registrationDealerships', 'Auction Access Dealerships'],
  ['registrationDealerships_v2', 'RegistrationDealershipsV2'],
  ['registrationAcvAccountCreation_v2', 'RegistrationAcvAccountCreationV2'],
  ['registrationAcvAccountCreationSuccess_v2', 'RegistrationAcvAccountCreationSuccessV2'],
  ['registrationAcvLogin_v2', 'RegistrationAcvLoginV2'],
  ['registrationAcvLoginSuccess_v2', 'RegistrationAcvLoginSuccessV2'],
  ['registrationDealerForm_v2', 'RegistrationDealerFormV2'],
  ['saved', 'saved'],
]);

export const pathNames = new Map([
  ['auctionAccessRegistration', '/registration'],
  ['emptyPath', ''],
  ['forgot', '/forgot'],
  ['login', '/login'],
  ['logout', '/logout'],
  ['myAcv', '/myacv'],
  ['password', '/password'],
  ['registration', '/registration'],
  ['registration_v2', '/registration-v2'],
  ['registrationForm', '/registration-form'],
  ['registrationForm_v2', '/registration-form-v2'],
  ['registrationEmailVerification_v2', '/registration-email-verification'],
  ['registrationAcvAccountCreation_v2', '/registration-acv-account-creation'],
  ['registrationSuccess_v2', '/registration-verification-success'],
  ['registrationDealerships', '/registration-dealerships'],
  ['registrationAcvLogin_v2', '/registration-acv-login'],
  ['registrationDealerships_v2', '/registration-dealerships-v2'],
  ['registrationDealerForm_v2', '/dealer-registration-form'],
]);
